// Single source of truth for dataflows MS integration processes.
// Adding an entry here will create a row in Processes and enable
// the Retry button in Flow & Data Management for the listed flow names.
export const DATAFLOWS_MS_PROCESSES = [
  {
    processDefinitionId: 'changeOfRegDetails',
    name: 'Start Change Of Reg Details',
    flowNames: [
      'CHANGE_OF_REG_DETAILS_SMSO_CHANGE',
      'CHANGE_OF_REG_DETAILS_ADDRESS_CHANGE',
      'CHANGE_OF_REG_DETAILS_LINKED_MPAN_ADD',
      'CHANGE_OF_REG_DETAILS_RELATED_MPAN_ADD',
      'CHANGE_OF_REG_DETAILS_IHD_STATUS_CHANGE',
      'CHANGE_OF_REG_DETAILS_LINKED_MPAN_CREATE',
      'CHANGE_OF_REG_DETAILS_RELATED_MPAN_CREATE',
      'CHANGE_OF_REG_DETAILS_RELATED_MPAN_REMOVE',
      'CHANGE_OF_REG_DETAILS__LINKED_MPAN_REMOVE',
      'CHANGE_OF_REG_DETAILS_DOM_INDICATOR_CHANGE',
      'CHANGE_OF_REG_DETAILS_CONSENT_GRANULARITY_CHANGE',
      'CHANGE_OF_REG_DETAILS_SSC_AND_PROFILE_CLASS',
    ],
  },
  {
    processDefinitionId: 'meteringServiceChange',
    name: 'Start Metering Service Change',
    flowNames: ['METERING_SERVICE_APPOINTMENT'],
  },
  {
    processDefinitionId: 'consumptionAmendment',
    name: 'Start Consumption Amendment',
    flowNames: ['CONSUMPTION_AMENDMENT'],
  },
  {
    processDefinitionId: 'dataServiceChange',
    name: 'Start Data Service Change',
    flowNames: ['DATA_SERVICE_APPOINTMENT'],
  },
  {
    processDefinitionId: 'changeOfEnergisation',
    name: 'Start Change Of Energisation',
    flowNames: ['CHANGE_OF_ENERGISATION'],
  },
  {
    processDefinitionId: 'changeOfMetering',
    name: 'Start Change Of Metering',
    flowNames: ['CHANGE_OF_METERING'],
  },
  {
    processDefinitionId: 'disconnection',
    name: 'Start Disconnection',
    flowNames: ['DISCONNECTION'],
  },
  {
    processDefinitionId: 'changeOfAnnualConsumption',
    name: 'Change Annual Consumption',
    flowNames: ['ANNUAL_CONSUMPTION_CHANGE'],
  },
  {
    processDefinitionId: 'changeOfSupplier',
    name: 'Start Change Of Supplier',
    flowNames: ['CHANGE_OF_SUPPLIER'],
  },
  {
    processDefinitionId: 'changeOfCustomerContactDetails',
    name: 'Contact Details Change',
    flowNames: ['CONTACT_DETAILS_CHANGE'],
  },
];

// Derived map: flow name enum key -> processDefinitionId
export const FLOW_NAME_TO_PROCESS_MAP = DATAFLOWS_MS_PROCESSES.reduce((map, process) => {
  process.flowNames.forEach((flowName) => {
    map[flowName] = process.processDefinitionId;
  });
  return map;
}, {});

// Maps flow name enum keys to changeOfRegDetails change types
export const FLOW_NAME_TO_CHANGE_TYPE = {
  CHANGE_OF_REG_DETAILS_SMSO_CHANGE: 'SMSOChange',
  CHANGE_OF_REG_DETAILS_ADDRESS_CHANGE: 'AddressChange',
  CHANGE_OF_REG_DETAILS_LINKED_MPAN_ADD: 'LinkedMPANAdd',
  CHANGE_OF_REG_DETAILS_RELATED_MPAN_ADD: 'RelatedMPANAdd',
  CHANGE_OF_REG_DETAILS_IHD_STATUS_CHANGE: 'IHDStatusChange',
  CHANGE_OF_REG_DETAILS_LINKED_MPAN_CREATE: 'LinkedMPANCreate',
  CHANGE_OF_REG_DETAILS_RELATED_MPAN_CREATE: 'RelatedMPANCreate',
  CHANGE_OF_REG_DETAILS_RELATED_MPAN_REMOVE: 'RelatedMPANRemove',
  CHANGE_OF_REG_DETAILS__LINKED_MPAN_REMOVE: 'LinkedMPANRemove',
  CHANGE_OF_REG_DETAILS_DOM_INDICATOR_CHANGE: 'DomIndicatorChange',
  CHANGE_OF_REG_DETAILS_CONSENT_GRANULARITY_CHANGE: 'ConsentGranularityChange',
  CHANGE_OF_REG_DETAILS_SSC_AND_PROFILE_CLASS: 'SSCandProfileClass',
};
